import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";

import { AuthService } from "../../../core/services/auth.service";
import { AvatarComponent } from "../avatar/avatar.component";
import { IconComponent } from "../icon/icon.component";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [RouterLink, AvatarComponent, IconComponent],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {

  private readonly router = inject(Router);

  private readonly authService = inject(AuthService);

  protected readonly profile = this.authService.userProfile;

  protected readonly avatarUrl = this.authService.avatarUrl;

  protected readonly currentPageName = computed<string>(() => {
    const url = this.router.url;
    if (url === "/" || url.startsWith("/service-providers")) {
      return "Service Providers";
    }
    if (url.startsWith("/employees")) {
      return "Employees";
    }
    if (url.startsWith("/reports")) {
      return "Reports";
    }
    if (url.startsWith("/settings")) {
      return "Settings";
    }
    return "Home";
  });
}
